import { useEffect, useState } from "react"
import "./styles.scss"
import { useDispatch, useSelector } from "react-redux"
import { useQuery } from "../../../hooks"
import { Buttons, Inputs } from "../../../components"
import { applyUserFilterPreset, createUserFilterPreset, deleteUserFilterPreset, } from "../../../actions"
import { useTranslation } from 'react-i18next'


const TableFilterPresets = ({ close, defaultFields, currentFields, setCurrentFields, lockedColumns, type, selectedFilterPreset, setPreset, manageColumns }) => {
    const defaultPreset = {
        fields: defaultFields,
        lockedColumns: [],
        sort: null,
        filter: null,
    }
    const { t } = useTranslation()
    const dispatch = useDispatch()
    const { sort, filter } = useQuery()
    const { filterPresets: filters = [] } = useSelector(({ general }) => general?.user) || {}

    const [saveFilter, setSaveFilter] = useState(false)
    const [filterName, setFilterName] = useState('')
    useEffect(() => { setFilterName('') }, [saveFilter])

    return <div className="popup-table-filter-presets-container">
        <div className="row">
            <h4>{t('shared.filterPresets')}</h4>
            <div className="icon icon-x" onClick={close} />
        </div>
        <div className="scroll-container">
            {filters?.length ? <Inputs.RadioButtons
                options={filters?.filter((f) => f.type === type)?.map(({ _id, name }) => ({ value: _id, label: name }))}
                value={selectedFilterPreset?._id}
                deselect
                onChange={(_id) => dispatch(applyUserFilterPreset({ payload: { presetId: _id, type }, onSuccess: () => { if (!_id) setPreset(defaultPreset) } }))}
                col
                renderButton={({ label, value }) => <span style={{ display: 'inline-flex', alignItems: 'center', justifyContent: 'space-between', width: '100%' }}>
                    <p>{label}</p>
                    <span
                        style={{ display: 'inline-block', width: 20, height: 20, marginLeft: 15 }}
                        className="icon icon-delete"
                        onClick={(e) => {
                            e.stopPropagation()
                            dispatch(deleteUserFilterPreset({ payload: value, onSuccess: () => { if (selectedFilterPreset?._id === value) setPreset(defaultPreset) } }))
                        }} />
                </span>}
            /> : <p>{t('shared.filterPresetsEmpty')}</p>}
        </div>
        <div className="buttons">
            <Buttons.Raised
                text={t('shared.manageColumns')}
                onClick={() => { manageColumns(); close() }}
            />
            <Buttons.Raised
                text={t('shared.filterPresetsSave')}
                className="btn-show-save"
                onClick={() => setSaveFilter(true)}
            />
            <Buttons.Raised
                text={t('shared.filterPresetsClear')}
                onClick={() => dispatch(applyUserFilterPreset({ payload: { presetId: null, type }, onSuccess: () => setPreset(defaultPreset) }))}
            />
            <Buttons.Raised text={t('shared.filterPresetsShowAllColumns')} onClick={() => setCurrentFields(defaultFields)} />
            <div className={`save-filter ${saveFilter && 'show'} col`}>
                <h4>{t('shared.filterPresetsName')}</h4>
                <Inputs.Text value={filterName || ''} onChange={({ target: { value } }) => setFilterName(value)} />
                <div className="row">
                    <Buttons.Raised text={t('shared.cancel')} onClick={() => setSaveFilter(false)} />
                    <Buttons.Raised
                        text={t('shared.save')}
                        className="btn-save"
                        onClick={() => dispatch(createUserFilterPreset({ payload: { name: filterName, type, preset: { fields: currentFields, lockedColumns, sort, filter } }, onSuccess: () => setSaveFilter(false) }))}
                    />
                </div>
            </div>
        </div>
    </div>
}

export default TableFilterPresets